<template>
  <v-card flat >
    <v-img
      class="black--text"
      height="200px"
      :src="mapUrl(location)" >
      <v-container fill-height fluid>
        <v-layout fill-height>
          <v-flex xs12 align-end flexbox>
            <span class="headline elevation-10 pa-2 white">{{location.name}}</span>
          </v-flex>
        </v-layout>
      </v-container>
    </v-img>
    <v-card-title>{{location.address}}</v-card-title>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click='$emit("edit")' flat ><v-icon>edit</v-icon> Edit address</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'LocationView',
  props: {
    location: { type: Object, default: () => { return { address: {} } } }
  },
  methods: {
    mapUrl (addr) {
      let lat = addr.latitude
      let lng = addr.longitude
      return `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=14&size=640x180&scale=2&markers=color:blue%7C${lat},${lng}&key=AIzaSyDBLqBJhup-u2afKcqqonWzGC-vv_7YpnY`
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// LocationView.vue?ebd25200